import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CardV2 as Card, Table } from '@feathr/components';
import { useLocalUrl, useStore } from '@feathr/extender/state';

import { growthCreditsFormsColumns } from './growthCreditsFormsColumns';

function GrowthCreditsFormsTable(): JSX.Element {
  const { t } = useTranslation();
  const { DonationForms } = useStore();
  const localUrl = useLocalUrl();

  return (
    <Card width={'full'}>
      <Card.Header
        description={t('See which forms are generating the most credits from donor tips')}
        title={t('Credits by donation form')}
      />
      <Card.Content padding={'none'}>
        <Table
          collection={DonationForms}
          columns={growthCreditsFormsColumns({ t, localUrl })}
          initialSort={[{ id: 'stats_cache__growth_credits', desc: true }]}
        />
      </Card.Content>
    </Card>
  );
}

export default observer(GrowthCreditsFormsTable);
